module.exports = __webpack_public_path__ + "static/media/click_action.6ea51a5b.svg";